import { captureExceptionWithMessage } from './logRocket'

declare global {
  interface Window {
    analytics: any
  }
}

export enum TrackType {
  INSIGHT_FEED_SHOW_MORE_CONTACTS = 'INSIGHT_FEED_SHOW_MORE_CONTACTS',
  INSIGHT_FEED_CONVERSATION_CLICK = 'INSIGHT_FEED_CONVERSATION_CLICK',
  INSIGHT_FEED_OUTREACH_ENROLL_CLICK = 'INSIGHT_FEED_OUTREACH_ENROLL_CLICK',
  INSIGHT_FEED_SALESLOFT_ENROLL_CLICK = 'INSIGHT_FEED_SALESLOFT_ENROLL_CLICK',
  INSIGHT_FEED_LINKEDIN_CLICK = 'INSIGHT_FEED_LINKEDIN_CLICK',
  INSIGHT_FEED_EMAIL_CLICK = 'INSIGHT_FEED_EMAIL_CLICK',
  INSIGHT_FEED_CHAT_CLICK = 'INSIGHT_FEED_CHAT_CLICK',
  INSIGHT_FEED_VIEW_CONTACT = 'INSIGHT_FEED_VIEW_CONTACT',
  INSIGHT_FEED_VIEW_ACCOUNT = 'INSIGHT_FEED_VIEW_ACCOUNT',
  ENGAGEMENT_SCORE_CARD_VIEW_ACTIVITY_CLICK = 'ENGAGEMENT_SCORE_CARD_VIEW_ACTIVITY_CLICK',
  ENGAGEMENT_SCORE_CARD_SEE_MORE_CONTACTS_CLICK = 'ENGAGEMENT_SCORE_CARD_SEE_MORE_CONTACTS_CLICK',
  ENGAGEMENT_SCORE_CARD_VIEW_CONTACT_CLICK = 'ENGAGEMENT_SCORE_CARD_VIEW_CONTACT_CLICK',
  ENGAGEMENT_SCORE_CARD_VIEW_ACCOUNT_CLICK = 'ENGAGEMENT_SCORE_CARD_VIEW_ACCOUNT_CLICK',
  ENGAGEMENT_SCORE_TOOLTIP_HOVER = 'ENGAGEMENT_SCORE_TOOLTIP_HOVER',
  AI_ENGAGEMENT_SCORE_TOOLTIP_HOVER = 'AI_ENGAGEMENT_SCORE_TOOLTIP_HOVER',
  ENGAGEMENT_SCORE_TOOLTIP_VIEW_ACTIVITY_CLICK = 'ENGAGEMENT_SCORE_TOOLTIP_VIEW_ACTIVITY_CLICK',
  AI_ENGAGEMENT_SCORE_TOOLTIP_VIEW_ACTIVITY_CLICK = 'AI_ENGAGEMENT_SCORE_TOOLTIP_VIEW_ACTIVITY_CLICK',
  CONTACT_LIST_CONVERSATION_CLICK = 'CONTACT_LIST_CONVERSATION_CLICK',
  CONTACT_LIST_OUTREACH_ENROLL_CLICK = 'CONTACT_LIST_OUTREACH_ENROLL_CLICK',
  CONTACT_LIST_SALESLOFT_ENROLL_CLICK = 'CONTACT_LIST_SALESLOFT_ENROLL_CLICK',
  CONTACT_LIST_CONTACT_INFO_CLICK = 'CONTACT_LIST_SALESLOFT_ENROLL_CLICK',
  CONTACT_LIST_LINKEDIN_CLICK = 'CONTACT_LIST_LINKEDIN_CLICK',
  CONTACT_LIST_EMAIL_CLICK = 'CONTACT_LIST_EMAIL_CLICK',
  INSIGHT_FEED_SCROLL = 'INSIGHT_FEED_SCROLL',

  ACCOUNT_PAGE_ACCESSED = 'ACCOUNT_PAGE_ACCESSED',
  ACTIVITY_PAGE_ACCESSED = 'ACTIVITY_PAGE_ACCESSED',
  ACCOUNT_DETAILS_PAGE_ACCESSED = 'ACCOUNT_DETAILS_PAGE_ACCESSED',
  ACCOUNT_SITE_VISIT_INFO_LINK_CLICKED = 'ACCOUNT_SITE_VISIT_INFO_LINK_CLICKED',
  ACCOUNT_SITE_VISIT_REFERRER_LINK_CLICKED = 'ACCOUNT_SITE_VISIT_REFERRER_LINK_CLICKED',
  CONTACT_DETAILS_PAGE_ACCESSED = 'CONTACT_DETAILS_PAGE_ACCESSED',
  SUBMITTED_FEEDBACK_FORM = 'SUBMITTED_FEEDBACK_FORM',
  MANAGE_NOTIFICATIONS_BUTTON_CLICKED = 'MANAGE_NOTIFICATIONS_BUTTON_CLICKED',
  ACCOUNT_DETAILS_VIEW_DOMAIN_CLICK = 'ACCOUNT_DETAILS_VIEW_DOMAIN_CLICK',
  ACCOUNT_DETAILS_CONTACT_ROW_CLICK = 'ACCOUNT_DETAILS_CONTACT_ROW_CLICK',
  CONTACT_DETAILS_CHAT_MESSAGE = 'CONTACT_DETAILS_CHAT_MESSAGE',
  CONTACT_DETAILS_VIEW_CHAT = 'CONTACT_DETAILS_VIEW_CHAT',
  CONTACT_DETAILS_SEND_EMAIL = 'CONTACT_DETAILS_SEND_EMAIL',
  CONTACT_DETAILS_COPY_EMAIL = 'CONTACT_DETAILS_COPY_EMAIL',
  CONTACT_DETAILS_VIEW_ACCOUNT = 'CONTACT_DETAILS_VIEW_ACCOUNT',
  MEETING_TRANSCRIPT_TOGGLED = 'MEETING_TRANSCRIPT_TOGGLED',
  LOADED_MISSED_ACCOUNTS_REPORT = 'LOADED_MISSED_ACCOUNTS_REPORT',
  // CCRM session metrics
  CCRM_SESSION_START = 'CCRM_SESSION_START',
  CCRM_SESSION_SHORT = 'CCRM_SESSION_SHORT',
  CCRM_SESSION_MEDIUM = 'CCRM_SESSION_MEDIUM',
  CCRM_SESSION_LONG = 'CCRM_SESSION_LONG',
  CCRM_FEED_CARD_DWELL_TIME = 'CCRM_FEED_CARD_DWELL_TIME',
  COPIED_LINK_TO_CCRM_FEED_CARD = 'COPIED_LINK_TO_CCRM_FEED_CARD',
  // Insight Card Page metrics
  INSIGHT_CARD_PAGE_LINKEDIN_CLICK = 'INSIGHT_CARD_PAGE_LINKEDIN_CLICK',
  INSIGHT_CARD_PAGE_CHAT_CLICK = 'INSIGHT_CARD_PAGE_CHAT_CLICK',
  INSIGHT_CARD_PAGE_OUTREACH_ENROLL_CLICK = 'INSIGHT_CARD_PAGE_OUTREACH_ENROLL_CLICK',
  INSIGHT_CARD_PAGE_SALESLOFT_ENROLL_CLICK = 'INSIGHT_CARD_PAGE_SALESLOFT_ENROLL_CLICK',
  INSIGHT_CARD_PAGE_EMAIL_CLICK = 'INSIGHT_CARD_PAGE_EMAIL_CLICK',
  BACK_TO_FEED_FROM_INSIGHT_CARD_PAGE = 'BACK_TO_FEED_FROM_INSIGHT_CARD_PAGE',
  INSIGHT_CARD_PAGE_OPENED = 'INSIGHT_CARD_PAGE_OPENED',
  // Commenting
  COMMENT_CREATED = 'COMMENT_CREATED',
  COMMENT_UPDATED = 'COMMENT_UPDATED',
  COMMENT_DELETED = 'COMMENT_DELETED',
  COMMENT_ACTION_CLICKED = 'COMMENT_ACTION_CLICKED',
  COMMENT_COUNT_CLICKED = 'COMMENT_COUNT_CLICKED',
  // Timeline
  TIMELINE_MONTH_CHANGE = 'TIMELINE_MONTH_CHANGE',
  TIMELINE_DAY_HOVERED = 'TIMELINE_DAY_HOVERED',
  TIMELINE_DAY_CLICKED = 'TIMELINE_DAY_CLICKED',
  // ACCOUNT ENGAGEMENT
  SCORE_GRAPH_TOOLTIP_HOVER = 'SCORE_GRAPH_TOOLTIP_HOVER',
  ACCOUNTS_TABLE_LOADED = 'ACCOUNTS_TABLE_LOADED',

  // Dashboard Stats
  DASHBOARD_PAGE_ACCESSED = 'DASHBOARD_PAGE_ACCESSED',
  SAVED_FILTER_SELECTED_DASHBOARD = 'SAVED_FILTER_SELECTED_DASHBOARD',
  DASHBOARD_SEARCH = 'DASHBOARD_SEARCH',

  //Filters
  SAVED_FILTER_MODAL_OPENED = 'SAVED_FILTER_MODAL_OPENED',
  REMOVE_FILTER = 'REMOVE_FILTER',
  CLEAR_FILTERS = 'CLEAR_FILTERS',
  FILTER_TOGGLED = 'FILTER_TOGGLED',
  FILTER_ADDED = 'FILTER_ADDED',
  SEARCH = 'SEARCH',
  FILTER_GROUP_ADDED = 'FILTER_GROUP_ADDED',
  SAVED_FILTER_CREATED = 'SAVED_FILTER_CREATED',
  SAVED_FILTER_SELECTED = 'SAVED_FILTER_SELECTED',
  SAVED_FILTER_UPDATED = 'SAVED_FILTER_UPDATED',
  SAVED_FILTER_DELETED = 'SAVED_FILTER_DELETED',
  FIRMOGRAPHIC_FILTER_ADDED = 'FIRMOGRAPHIC_FILTER_ADDED',
  // ADMIN_MANAGED_FILTERS
  ADMIN_MANAGED_FILTER_SETTINGS_VIEWED = 'ADMIN_MANAGED_FILTER_SETTINGS_VIEWED',
  ADMIN_MANAGED_FILTER_SETTINGS_TEAM_ASSIGNED = 'ADMIN_MANAGED_FILTER_SETTINGS_TEAM_ASSIGNED',
  ADMIN_MANAGED_FILTER_SETTINGS_USER_ASSIGNED = 'ADMIN_MANAGED_FILTER_SETTINGS_USER_ASSIGNED',
  ADMIN_MANAGED_FILTER_CREATED = 'ADMIN_MANAGED_FILTER_CREATED',
  ADMIN_MANAGED_FILTER_UPDATED = 'ADMIN_MANAGED_FILTER_SETTINGS_UPDATED',
  // FILTERS_SETTINGS_MODAL
  FILTERS_SETTINGS_MODAL_OPENED = 'SETTINGS_FILTERS_MODAL_OPENED',
  FILTERS_SETTINGS_MODAL_CHANGE_DEFAULT_FILTER = 'FILTERS_SETTINGS_MODAL_CHANGE_DEFAULT_FILTER',
  FILTERS_SETTINGS_MODAL_EDIT_FILTER_MODAL_OPEN = 'FILTERS_SETTINGS_MODAL_EDIT_FILTER_MODAL_OPEN',
  FILTERS_SETTINGS_MODAL_DELETE_FILTER_MODAL_OPEN = 'FILTERS_SETTINGS_MODAL_DELETE_FILTER_MODAL_OPEN',
  FILTERS_SETTINGS_MODAL_CHANGE_NOTIFICATION_SETTINGS = 'FILTERS_SETTINGS_MODAL_CHANGE_NOTIFICATION_SETTINGS',
  // ONBOARDING SHEPHERD
  // tour events
  DASHBOARD_ONBOARDING_SHEPHERD_TOUR_STARTED = 'DASHBOARD_ONBOARDING_SHEPHERD_TOUR_STARTED',
  DASHBOARD_ONBOARDING_SHEPHERD_TOUR_COMPLETED = 'DASHBOARD_ONBOARDING_SHEPHERD_TOUR_COMPLETED',
  DASHBOARD_ONBOARDING_SHEPHERD_TOUR_DISMISSED = 'DASHBOARD_ONBOARDING_SHEPHERD_TOUR_DISMISSED',
  DASHBOARD_ONBOARDING_SHEPHERD_TOUR_STARTED_ON_MOUNT = 'DASHBOARD_ONBOARDING_SHEPHERD_TOUR_STARTED_ON_MOUNT',
  DASHBOARD_ONBOARDING_SHEPHERD_TOUR_STARTED_ON_USER_ACTION = 'DASHBOARD_ONBOARDING_SHEPHERD_TOUR_STARTED_ON_USER_ACTION',
  // step events
  DASHBOARD_ONBOARDING_SHEPHERD_AI_ENGAGEMENT_STEP_VIEWED = 'DASHBOARD_ONBOARDING_SHEPHERD_AI_ENGAGEMENT_STEP_VIEWED',
  DASHBOARD_ONBOARDING_SHEPHERD_NOTIFICATIONS_STEP_VIEWED = 'DASHBOARD_ONBOARDING_SHEPHERD_NOTIFICATIONS_STEP_VIEWED',
  DASHBOARD_ONBOARDING_SHEPHERD_SAVED_FILTERS_STEP_VIEWED = 'DASHBOARD_ONBOARDING_SHEPHERD_SAVED_FILTERS_STEP_VIEWED',
  DASHBOARD_ONBOARDING_SHEPHERD_LEARN_MORE_BUTTON_CLICKED = 'DASHBOARD_ONBOARDING_SHEPHERD_LEARN_MORE_BUTTON_CLICKED',
  // LAST TOUCH
  LAST_TOUCH_NAVIGATES_TO_SALESFORCE = 'LAST_TOUCH_NAVIGATES_TO_SALESFORCE',
  LAST_TOUCH_NAVIGATES_TO_SALESFORCE_FROM_ACTIVITY_PAGE = 'LAST_TOUCH_NAVIGATES_TO_SALESFORCE_FROM_ACTIVITY_PAGE',
  LAST_TOUCH_NAVIGATES_TO_CONTACT_DETAILS = 'LAST_TOUCH_NAVIGATES_TO_CONTACT_DETAILS',
  LAST_TOUCH_USER_HAS_GATE = 'LAST_TOUCH_USER_HAS_GATE',
  LAST_TOUCH_FILTER_USE = 'LAST_TOUCH_FILTER_USE',
  // FILTER BUTTON TOOLTIP
  FILTER_BUTTON_TOOLTIP_VIEWED = 'FILTER_BUTTON_TOOLTIP_VIEWED',
  FILTER_BUTTON_TOOLTIP_START_FILTERING_CLICKED = 'FILTER_BUTTON_TOOLTIP_START_FILTERING_CLICKED',
  FILTER_BUTTON_TOOLTIP_LEARN_MORE_CLICKED = 'FILTER_BUTTON_TOOLTIP_LEARN_MORE_CLICKED',
  // SFDC OPEN OPPORTUNITIES
  SFDC_OPEN_OPPORTUNITIES_TAB_VIEWED = 'SFDC_OPEN_OPPORTUNITIES_TAB_VIEWED',
  SFDC_ALL_OPPORTUNITIES_FILTER_CLICKED = 'SFDC_ALL_OPPORTUNITIES_FILTER_CLICKED',
  SDFC_NO_OPPORTUNITIES_FILTER_CLICKED = 'SDFC_NO_OPPORTUNITIES_FILTER_CLICKED',
  SFDC_OPEN_OPPORTUNITIES_FILTER_CLICKED = 'SFDC_OPEN_OPPORTUNITIES_FILTER_CLICKED',
  // ACCOUNT DETAILS HEADER
  ACCOUNT_DETAILS_HEADER_NAVIGATES_TO_SALESFORCE = 'ACCOUNT_DETAILS_HEADER_NAVIGATES_TO_SALESFORCE',
  ACCOUNT_DETAILS_HEADER_NAVIGATES_TO_LINKEDIN = 'ACCOUNT_DETAILS_HEADER_NAVIGATES_TO_LINKEDIN',
  ACCOUNT_DETAILS_HEADER_NAVIGATES_TWITTER = 'ACCOUNT_DETAILS_HEADER_NAVIGATES_TWITTER',
  ACCOUNT_DETAILS_HEADER_NAVIGATES_ACCOUNT_PAGE = 'ACCOUNT_DETAILS_HEADER_NAVIGATES_ACCOUNT_PAGE',
  // ACCOUNT DETAILS TOP VISITORS
  ACCOUNT_DETAILS_TOP_VISITORS_NAVIGATES_TO_CONTACT_PAGE = 'ACCOUNT_DETAILS_TOP_VISITORS_NAVIGATES_TO_CONTACT_PAGE',
  // DEMO CONTROLS
  DEMO_CONTROLS_PAGE_LOAD = 'DEMO_CONTROLS_PAGE_LOAD',
  DEMO_CONTROLS_TRIGGER_DIGEST_EMAIL = 'DEMO_CONTROLS_TRIGGER_DIGEST_EMAIL',
  DEMO_CONTROLS_SETUP_PERSONALIZED_DEMO = 'DEMO_CONTROLS_SETUP_PERSONALIZED_DEMO',
  // AI ACCOUNT SUMMARY
  ACCOUNT_SUMMARY_WAS_HELPFUL = 'ACCOUNT_SUMMARY_WAS_HELPFUL',
  ACCOUNT_SUMMARY_ERROR = 'ACCOUNT_SUMMARY_ERROR',
  // GLOBAL FILTERS
  GLOBAL_FILTERS_CHANGED = 'GLOBAL_FILTERS_CHANGED',
  // ACCOUNT DRAWER
  OPEN_DRAWER = 'OPEN_DRAWER',
  CLOSE_DRAWER = 'CLOSE_DRAWER',
  DRAWER_ACTION = 'DRAWER_ACTION',
  DRAWER_ERROR = 'DRAWER_ERROR',
  RECOMMENDED_CONTACTS_EMPTY = 'RECOMMENDED_CONTACTS_EMPTY',
  // ACCOUNT FIT + ICP SETTINGS
  ACCOUNT_FIT_SCORE_TOGGLED = 'ACCOUNT_FIT_SCORE_TOGGLED',
  ACCOUNT_FIT_DRAWER_VIEWED = 'ACCOUNT_FIT_DRAWER_VIEWED',
  ACCOUNT_FIT_TOOLTIP_CLICK = 'ACCOUNT_FIT_TOOLTIP_CLICK',
  ACCOUNT_FIT_LOCK_CLICK = 'ACCOUNT_FIT_LOCK_CLICK',
  ACCOUNT_FIT_ICP_SETTINGS_CHANGED = 'ACCOUNT_FIT_ICP_SETTINGS_CHANGED',
  //ACTIVITY TIMELINE
  ACTIVITY_TIMELINE_ACTION = 'ACTIVITY_TIMELINE_ACTION',
  // EMAIL AUTOMATION
  AUTOMATION_PAGE_VIEW = 'AUTOMATION_PAGE_VIEW',
  AUTOMATION_EMAIL_PREVIEW = 'AUTOMATION_EMAIL_PREVIEW'
}

/**
 * @description Track events to Segment and Google Analytics
 * @param {TrackType} event - The event name to track in segment and GA
 * @param {Object} attrs - The attributes to send with the event (optional)
 *
 * @see Google_Analytics_Instance https://analytics.google.com/analytics/web/#/p338066057/reports/intelligenthome
 *
 * GOOGLE ANALYTICS ADMIN USERS:
 * - Mike McGrath (mmcgrath@drift.com)
 * - Peter Templin (ptemplin@drift.com)
 * - Miro Jelicic (mjelicic@drift.com)
 *
 */

export const segmentTrack = (event: TrackType, attrs = {}) => {
  try {
    if (typeof window?.analytics?.track === 'function') {
      window.analytics.track(`PROSPECTOR_${event}`, attrs)
    }

    if (typeof window?.gtag === 'function') {
      window.gtag('event', `PROSPECTOR_${event}`, attrs)
    }
  } catch (e) {
    // Send failed tracking events to Sentry
    captureExceptionWithMessage('Error tracking event', e, { event, attrs })
  }
}
